/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */

import React, { useState } from "react";
import { changePassword } from "../../../api/UserServices";
import ChangePassword from "../components/ChangePassword";
import validateForm from "../../../common/utils/validateForm";

const ChangePasswordContainer = () => {
  const [resetPasswordData, setResetPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [changePasswordInProgress, setChangePasswordInProgress] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState({
    type: null,
    message: "",
  });

  const methods = validateForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    validateCriteriaMode: "all",
  });
  const {
    register, errors, handleSubmit, clearErrors,
  } = methods;

  const handleSubmitResetPasswordDetails = () => {
    const requestData = {
      currentPassword: resetPasswordData.currentPassword,
      newPassword: resetPasswordData.newPassword,
    };
    setChangePasswordInProgress(true);
    changePassword(requestData).then((response) => {
      setChangePasswordInProgress(false);
      if (response && response.success) {
        setMessage({ type: "success", message: "Password updated successfully" });
        setTimeout(() => {
          setMessage({ type: null, message: "" });
          setResetPasswordData({
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        }, 3000);
      } else {
        setError("The current password is incorrect");
      }
    });
  };

  /**
* This method is used to handle change in text
*
* @param {String} key
* @param {Object} e
*/
  const handleChange = (e) => {
    setError("");
    const key = e.target.name;
    clearErrors([key]);
    setResetPasswordData({ ...resetPasswordData, [key]: e.target.value });
  };

  const toggleShowCurrentPassword = () => setShowCurrentPassword(!showCurrentPassword);

  const toggleShowNewPassword = () => setShowNewPassword(!showNewPassword);

  const toggleShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

  return (
    <>
      <ChangePassword
        resetPasswordData={resetPasswordData}
        handleChange={handleChange}
        handleSubmitResetPasswordDetails={handleSubmitResetPasswordDetails}
        toggleShowCurrentPassword={toggleShowCurrentPassword}
        showCurrentPassword={showCurrentPassword}
        toggleShowNewPassword={toggleShowNewPassword}
        showNewPassword={showNewPassword}
        toggleShowConfirmPassword={toggleShowConfirmPassword}
        showConfirmPassword={showConfirmPassword}
        changePasswordInProgress={changePasswordInProgress}
        error={error}
        handleSubmit={handleSubmit}
        register={register}
        errors={errors}
        message={message}
      />
    </>
  );
};
export default ChangePasswordContainer;
